import React, { useState } from "react";
import { usePosition } from "use-position";
import _ from "lodash";
import CurrentLocation from "./view";
import Api from "../../../../../lib/api";

function CurrentLocationContainer({ onFetchLocation }) {
    const [city, setCity] = useState("");
    const watch = true;
    const { latitude, longitude, error } = usePosition(watch, { enableHighAccuracy: true });

    const fetchCity = (lat, lng) =>
        new Promise((resolve, reject) => {
            Api.get("city_of_location", {
                params: {
                    latitude: lat,
                    longitude: lng,
                },
            })
                .then((data) => {
                    const entity = _.find(data.entities.cities);
                    setCity(entity.attributes);
                    resolve(entity);
                })
                .catch((error) => {
                    console.log(error);
                    reject(error);
                });
        });

    const onUsingCurrentLocation = (isSelected) => {
        if (isSelected) {
            fetchCity(latitude, longitude)
                .then((data) => {
                    onFetchLocation({ latitude, longitude }, data);
                })
                .catch((error) => {
                    onFetchLocation({ latitude: null, longitude: null }, null);
                });
        } else {
            setCity("");
            onFetchLocation({ latitude: null, longitude: null }, null);
        }
    };

    const cityName = city.nameEn || "";

    return (
        <CurrentLocation
            latitude={latitude}
            longitude={longitude}
            cityName={cityName}
            error={error}
            onUsingCurrentLocation={onUsingCurrentLocation}
        />
    );
}

export default CurrentLocationContainer;
